// src/views/components/Motion/CursorGlow.jsx
import React, { useEffect, useState } from 'react';
import { motion, useMotionValue, useSpring, useReducedMotion } from 'framer-motion';

const CursorGlow = () => {
  const [isVisible, setIsVisible] = useState(false);
  const shouldReduceMotion = useReducedMotion();

  const rawX = useMotionValue(-160);
  const rawY = useMotionValue(-160);

  const x = useSpring(rawX, { stiffness: 400, damping: 30, mass: 0.2 });
  const y = useSpring(rawY, { stiffness: 400, damping: 30, mass: 0.2 });

  useEffect(() => {
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || shouldReduceMotion) {
      return;
    }

    const handleMouseMove = (e) => {
      rawX.set(e.clientX - 160);
      rawY.set(e.clientY - 160);
      if (!isVisible) setIsVisible(true);
    };

    const handleMouseLeave = () => setIsVisible(false);

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    document.body.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.body.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [isVisible, rawX, rawY, shouldReduceMotion]);

  if (shouldReduceMotion || !isVisible) return null;

  return (
    <motion.div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '320px',
        height: '320px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(185, 28, 28, 0.12) 0%, rgba(185, 28, 28, 0.03) 45%, transparent 70%)',
        pointerEvents: 'none',
        zIndex: 9999,
        mixBlendMode: 'screen',
        willChange: 'transform',
        x,
        y,
      }}
    />
  );
};

export default CursorGlow;
